// Safe wrapper around the Meta (Facebook) Pixel.
// The Pixel base code is loaded in index.html; this just fires events
// and no-ops if fbq isn't available (e.g. content blockers).

export function trackEvent(name, data = {}) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', name, data);
  }
}

export function trackLead(value, source) {
  trackEvent('Lead', {
    content_name: source,
    content_category: source,
    ...(typeof value === 'number' && Number.isFinite(value) ? { value, currency: 'GBP' } : {}),
  });
}

export function trackPurchase(value) {
  trackEvent('Purchase', {
    ...(typeof value === 'number' && Number.isFinite(value) ? { value, currency: 'GBP' } : {}),
  });
}